import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationCardComponent } from './registration-card/registration-card.component';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { DataCardComponent } from './data-card/data-card.component';
import { DataListComponent } from './data-list/data-list.component';
import { MenuPopoverComponent } from './registration-card/menu-popover/menu-popover.component';
import { TableListComponent } from './table-list/table-list.component';
import { InnerHeaderComponent } from './inner-header/inner-header.component';
import { OptionsPopoverComponent } from './table-list/options-popover/options-popover.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { EmptyDataComponent } from './empty-data/empty-data.component';
import { ShimmerComponent } from './shimmer/shimmer.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormElementsModule } from '../form-elements/form-elements.module';
import { CustomPipeModule } from '../core/pipes/pipe.module';
import { PageTitleComponent } from './page-title/page-title.component';

@NgModule({
  declarations: [
    RegistrationCardComponent,
    HeaderComponent,
    DataCardComponent,
    DataListComponent,
    TableListComponent,
    MenuPopoverComponent,
    OptionsPopoverComponent,
    BreadcrumbComponent,
    InnerHeaderComponent,
    EmptyDataComponent,
    ShimmerComponent,
    PageTitleComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    IonicModule,
    RouterModule,
    FormElementsModule,
    CustomPipeModule,
    NgxPaginationModule,
  ],
  exports: [
    RegistrationCardComponent,
    HeaderComponent,
    TableListComponent,
    DataCardComponent,
    InnerHeaderComponent,
    BreadcrumbComponent,
    PageTitleComponent,
  ],
})
export class UiModule {}
